import types from './InventoryFileCategory';

/**
 * Человекочитаемые названия категорий вложений. Ключ — код категории.
 *
 * Зеркало App\Enums\InventoryFileCategoryTitle. Незнакомый код названия не имеет: список
 * вложений показывает category_title с бэкенда, а если и его нет — сам код. Так новая
 * категория не ломает уже выкаченный фронт.
 */
export default class InventoryFileCategoryTitle {
    static [types.GENERAL] = 'Общее';
    static [types.WAREHOUSE_RECEIVE] = 'Приёмка на склад';
    static [types.ISSUE_TO_EMPLOYEE] = 'Выдача сотруднику';
    static [types.RETURN_TO_WAREHOUSE] = 'Возврат на склад';
    static [types.REPAIR_SEND] = 'Отправка в ремонт';
    static [types.REPAIR_RETURN] = 'Возврат из ремонта';
    static [types.WRITEOFF] = 'Списание';
    static [types.OTHER] = 'Прочее';
}
